module.exports = __webpack_public_path__ + "static/media/plan-C2b-desktop-tc.137c34b8.png";